export default __webpack_public_path__ + "static/media/Bbpslogo3.b9fa9ee5.svg";